import React from "react";
import mainImg from "./assets/criteria-8.1.jpg";

export default function Desktop({ common: { data } }) {
  return (
    <div className="layout-pic desktop">
      <div className="wrapper">
        <div className="main-img">
          <img src={mainImg} alt="" />
        </div>
        <div className="text-container">
          <div class="text-wrapper">
            <div class="excerpt1">
              <span>Gracias por confiar en nosotros</span>
            </div>
          </div>
        </div>
      </div>
      <div className="text-bottom">
        <div class="excerpt1">¿Tienes dudas de tu solicitud? Llámanos</div>
        <div class="phone">{data.phoneMask}</div>
      </div>
    </div>
  );
}
